import React from 'react';

export interface QrCategory {
  id: string | number;
  name: string;
  icon?: string;
}

interface CategoryNavProps {
  categories: QrCategory[];
  selectedCategory: string | number;
  onCategoryChange: (id: string | number) => void;
  isScrolled?: boolean;
}

export default function CategoryNav({
  categories,
  selectedCategory,
  onCategoryChange,
  isScrolled = false,
}: CategoryNavProps) {
  if (!categories || categories.length === 0) return null;
  // Keep the category bar visually consistent regardless of scroll position:
  // no divider line, no background color change when reaching the top.
  return (
    <div className="sticky top-[68px] z-30 py-4 bg-white/80 dark:bg-[#09090b]/80 backdrop-blur-xl">
      <div className="flex gap-2.5 overflow-x-auto px-5 scrollbar-hide qrm-no-select">
        {categories.map((category) => {
          const isActive = selectedCategory === category.id;
          return (
            <button
              key={category.id}
              type="button"
              onClick={() => onCategoryChange(category.id)}
              className={`relative px-5 py-2.5 rounded-full whitespace-nowrap text-[14px] font-semibold transition-all flex-shrink-0 ${isActive
                ? 'bg-gray-900 dark:bg-white text-white dark:text-gray-900 shadow-[0_4px_14px_0_rgba(0,0,0,0.1)] dark:shadow-[0_4px_14px_0_rgba(255,255,255,0.1)]'
                : 'bg-gray-100 dark:bg-white/5 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-white/10'
                }`}
            >
              {category.name}
            </button>
          );
        })}
      </div>
    </div>
  );
}
